import DatePicker from 'vue2-datepicker'

/**
 * Override the `updateCalendars` method from vue2-datepicker.
 * This modification is to fix the issue of the default displayed calendars
 * showing the current and the next month, which is not always desired.
 *
 * Reference:
 * - Issue: https://easyredmine.simpliciti.fr/issues/41063
 * - Author's Suggested Fix: https://github.com/mengxiong10/vue2-datepicker/issues/584#issuecomment-965938155
 * - isValidDate function: https://github.com/mengxiong10/vue2-datepicker/blob/master/src/util/date.js#L10C14-L10C14
 */

const originalUpdateCalendars = DatePicker.CalendarRange.methods.updateCalendars

function isValidDate(date) {
  return date instanceof Date && !isNaN(date.getTime())
}

DatePicker.CalendarRange.methods.updateCalendars = function (...args) {
  originalUpdateCalendars.apply(this, args)

  if (this.innerValue.length === 2 && this.innerValue.every(isValidDate)) {
    return
  }

  if (args.length === 1) {
    this.calendars = this.calendars.map((calendarDate) => {
      const newDate = new Date(calendarDate)
      newDate.setMonth(newDate.getMonth() - 1)

      return newDate
    })
  }
}
